import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';

export default function CustomerTestPage() {
  const [consulting, setConsulting] = useState(false);
  const [sandbox, setSandbox] = useState(false);
  const [searchParams] = useSearchParams();
  const [utmParams, setUtmParams] = useState({
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_term: '',
    utm_content: ''
  });

  useEffect(() => {
    setUtmParams({
      utm_source: searchParams.get('utm_source') || '',
      utm_medium: searchParams.get('utm_medium') || '',
      utm_campaign: searchParams.get('utm_campaign') || '',
      utm_term: searchParams.get('utm_term') || '',
      utm_content: searchParams.get('utm_content') || ''
    });
  }, [searchParams]);
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar isPublic={true} />
      
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white shadow rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Apply for Our Customer Test Program</h1>
          <p className="text-gray-600 mb-8">
            Help us shape the future of Salesforce Flow documentation. Fill out the form below to apply for our early access program.
          </p>

          <form 
            action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00Dak00000JFvuH" 
            method="POST"
            className="space-y-6"
          >
            <input type="hidden" name="oid" value="00Dak00000JFvuH" />
            <input type="hidden" name="retURL" value={`${window.location.origin}/customer-test-thank-you`} />
            <input type="hidden" name="Campaign_ID" value="701ak000019Ue2MAAS" />
            <input type="hidden" name="member_status" value="Responded" />
            
            {/* UTM Tracking Fields */}
            <input type="hidden" id="00Nak00000ZaRlj" name="00Nak00000ZaRlj" value={utmParams.utm_source} />
            <input type="hidden" id="00Nak00000ZaL5m" name="00Nak00000ZaL5m" value={utmParams.utm_medium} />
            <input type="hidden" id="00Nak00000ZaS4r" name="00Nak00000ZaS4r" value={utmParams.utm_campaign} />
            <input type="hidden" id="00Nak00000ZaSCv" name="00Nak00000ZaSCv" value={utmParams.utm_term} />
            <input type="hidden" id="00Nak00000ZaNlX" name="00Nak00000ZaNlX" value={utmParams.utm_content} />

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <label htmlFor="first_name" className="block text-sm font-medium text-gray-700">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  id="first_name"
                  name="first_name"
                  type="text"
                  maxLength={40}
                  required
                  className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                />
              </div>

              <div>
                <label htmlFor="last_name" className="block text-sm font-medium text-gray-700">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  id="last_name"
                  name="last_name"
                  type="text"
                  maxLength={80}
                  required
                  className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                maxLength={80}
                required
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              />
            </div>

            <div>
              <label htmlFor="company" className="block text-sm font-medium text-gray-700">
                Company <span className="text-red-500">*</span>
              </label>
              <input
                id="company"
                name="company"
                type="text"
                maxLength={40}
                required
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              />
            </div>

            <div>
              <label htmlFor="url" className="block text-sm font-medium text-gray-700">
                Website <span className="text-red-500">*</span>
              </label>
              <input
                id="url"
                name="url"
                type="url"
                maxLength={80}
                required
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              />
            </div>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <label htmlFor="title" className="block text-sm font-medium text-gray-700">
                  Title <span className="text-red-500">*</span>
                </label>
                <input
                  id="title"
                  name="title"
                  type="text"
                  maxLength={40}
                  required
                  className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                  Phone <span className="text-red-500">*</span>
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  maxLength={40}
                  required
                  className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                />
              </div>
            </div>

            <div>
              <label htmlFor="00Nak00000ZUwQb" className="block text-sm font-medium text-gray-700">
                Biggest Documentation Challenge <span className="text-red-500">*</span>
              </label>
              <select
                id="00Nak00000ZUwQb"
                name="00Nak00000ZUwQb"
                required
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              >
                <option value="">--None--</option>
                <option value="Initial cost">Initial cost</option>
                <option value="Maintenance cost">Maintenance cost</option>
                <option value="Wasted effort - it just becomes outdated">Wasted effort - it just becomes outdated</option>
                <option value="No one uses it">No one uses it</option>
                <option value="Inconsistent">Inconsistent</option>
                <option value="Other (note in comments)">Other (note in comments)</option>
              </select>
            </div>

            <div>
              <label htmlFor="00Nak00000Z7KPF" className="block text-sm font-medium text-gray-700">
                CRM <span className="text-red-500">*</span>
              </label>
              <select
                id="00Nak00000Z7KPF"
                name="00Nak00000Z7KPF"
                title="CRM"
                defaultValue="Salesforce"
                required
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              >
                <option value="">--None--</option>
                <option value="Salesforce">Salesforce</option>
                <option value="HubSpot">HubSpot</option>
                <option value="Pipedrive">Pipedrive</option>
                <option value="Monday">Monday</option>
                <option value="Apollo.io">Apollo.io</option>
                <option value="ZohoCRM">ZohoCRM</option>
                <option value="FreshSales">FreshSales</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div>
              <label htmlFor="00Nak00000ZZl6L" className="block text-sm font-medium text-gray-700">
                Salesforce Clouds <span className="text-red-500">*</span>
              </label>
              <select
                id="00Nak00000ZZl6L"
                multiple={true}
                name="00Nak00000ZZl6L"
                title="Salesforce Clouds"
                required
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                style={{ minHeight: '8rem' }}
              >
                <option value="Sales Cloud">Sales Cloud</option>
                <option value="Service Cloud">Service Cloud</option>
                <option value="Marketing Cloud">Marketing Cloud</option>
                <option value="Commerce Cloud">Commerce Cloud</option>
                <option value="Experience Cloud">Experience Cloud</option>
              </select>
              <p className="mt-1 text-sm text-gray-500">Hold Ctrl/Cmd to select multiple options</p>
            </div>

            <div>
              <label htmlFor="00Nak00000ZUwIX" className="block text-sm font-medium text-gray-700">
                Marketing Automation Platform <span className="text-red-500">*</span>
              </label>
              <select
                id="00Nak00000ZUwIX"
                name="00Nak00000ZUwIX"
                required
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              >
                <option value="">--None--</option>
                <option value="HubSpot">HubSpot</option>
                <option value="Marketo">Marketo</option>
                <option value="Marketing Cloud">Marketing Cloud</option>
                <option value="ActiveCampaign">ActiveCampaign</option>
                <option value="Other (specify in comments)">Other (specify in comments)</option>
                <option value="None">None</option>
              </select>
            </div>

            <div>
              <label htmlFor="00Nak00000ZUwLl" className="block text-sm font-medium text-gray-700">
                Estimated # of Flows <span className="text-red-500">*</span>
              </label>
              <select
                id="00Nak00000ZUwLl"
                name="00Nak00000ZUwLl"
                required
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              >
                <option value="">--None--</option>
                <option value="1-10">1-10</option>
                <option value="11-50">11-50</option>
                <option value="51-100">51-100</option>
                <option value="101-200">101-200</option>
                <option value="201-500">201-500</option>
                <option value="500+">500+</option>
              </select>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <label htmlFor="00Nak00000ZUuwg" className="block text-sm font-medium text-gray-700">
                  # of In-House Developers <span className="text-red-500">*</span>
                </label>
                <input
                  id="00Nak00000ZUuwg"
                  name="00Nak00000ZUuwg"
                  type="text"
                  required
                  className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                />
              </div>

              <div>
                <label htmlFor="00Nak00000ZUwNN" className="block text-sm font-medium text-gray-700">
                  # of External Agencies <span className="text-red-500">*</span>
                </label>
                <input
                  id="00Nak00000ZUwNN"
                  name="00Nak00000ZUwNN"
                  type="text"
                  required
                  className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
                />
              </div>
            </div>

            <div>
              <label htmlFor="00Nak00000ZUwiL" className="block text-sm font-medium text-gray-700">
                Compliance areas you need to document
              </label>
              <textarea
                id="00Nak00000ZUwiL"
                name="00Nak00000ZUwiL"
                rows={3}
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              />
            </div>

            <div>
              <label htmlFor="00Nak00000ZUwlZ" className="block text-sm font-medium text-gray-700">
                Comments
              </label>
              <textarea
                id="00Nak00000ZUwlZ"
                name="00Nak00000ZUwlZ"
                rows={3}
                className="mt-1 block w-full px-3 py-3 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-900"
              />
            </div>

            <div className="flex items-center">
              <input
                id="00Nak00000ZUwTp"
                name="00Nak00000ZUwTp"
                type="checkbox"
                value="1"
                checked={consulting}
                onChange={(e) => setConsulting(e.target.checked)}
                className="h-4 w-4 rounded border border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                style={{ 
                  backgroundColor: '#ffffff',
                  backgroundImage: consulting ? `url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='black' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e")` : 'none',
                  backgroundSize: '100% 100%',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  appearance: 'none'
                }}
              />
              <label htmlFor="00Nak00000ZUwTp" className="ml-2 block text-sm text-gray-900">
                I provide Salesforce consulting
              </label>
            </div>

            <div className="flex items-center">
              <input
                id="00Nak00000ZZjwA"
                name="00Nak00000ZZjwA"
                type="checkbox"
                value="1"
                checked={sandbox}
                onChange={(e) => setSandbox(e.target.checked)}
                className="h-4 w-4 rounded border border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                style={{ 
                  backgroundColor: '#ffffff',
                  backgroundImage: sandbox ? `url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='black' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e")` : 'none',
                  backgroundSize: '100% 100%',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  appearance: 'none'
                }}
              />
              <label htmlFor="00Nak00000ZZjwA" className="ml-2 block text-sm text-gray-900">
                I can make a Salesforce sandbox available during testing
              </label>
            </div>

            <div>
              <button
                type="submit"
                name="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Apply for Customer Test Program
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}